export default __webpack_public_path__ + "static/media/Lora-BoldItalic.bbda6e6e.ttf";